<template>
  <mdb-container fluid>
    <mdb-row>
      {{ $t("surrogate_tel_input_title") }}
    </mdb-row>
    <mdb-row>
      <mdb-col col="4">
        <mdb-input icon="quote-right" :label="$t('surrogate_tel_input')" type="text" v-model="surrogatetel" />
      </mdb-col>
      <mdb-col col="2">
        <mdb-btn color="indigo" @click="startFindingMemberIdDataWithCode">
          {{ $t("search") }}
        </mdb-btn>
      </mdb-col>
    </mdb-row>
    <mdb-row>
      <mdb-col>
        <H3>{{ $t("member_id") }}</H3>
        <mdb-datatable-2 v-if="dataLoadReady" v-model="surrogate" />
      </mdb-col>
    </mdb-row>
    <mdb-row>
      <mdb-col>
        <H3>{{ $t("customer_data") }}</H3>
        <mdb-datatable-2 v-if="dataLoadReady" v-model="customer" />
      </mdb-col>
    </mdb-row>
    <mdb-row v-if="customerIdMismatch">
      <mdb-col>
        <h2 class="red-text font-weight-bold">{{ $t("customer_mismatch") }}</h2>
      </mdb-col>
    </mdb-row>
    <mdb-row v-if="buttonsVisible">
      <mdb-col col="4">
        <mdb-btn color="green" @click="changeSurrogateToCustomer">
          {{ $t("change_member_id_to_customer") }}
        </mdb-btn>
      </mdb-col>
      <mdb-col col="4">
        <mdb-btn color="orange" @click="cleanSurrogate">
          {{ $t("clean_member_id") }}
        </mdb-btn>
      </mdb-col>
      <mdb-col col="4">
        <mdb-btn color="red" @click="deleteMemberIdData">
          {{ $t("delete_member_id") }}
        </mdb-btn>
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<script>
import { mdbContainer, mdbRow, mdbDatatable2, mdbInput, mdbCol, mdbBtn } from "mdbvue";
export default {
  name: "FindMemberIdsTogetherWithCustomer",
  components: {
    mdbContainer,
    mdbRow,
    mdbDatatable2,
    mdbInput,
    mdbCol,
    mdbBtn,
  },
  data() {
    return {
      surrogatetel: "",
      memberSearchModal: false,
      dataLoadReady: false,
      buttonsVisible: false,
      foundSurrogate: null,
      foundCustomerId: null,
      changecustomersurrogatepath: "/1.0/front/customer/surrogatetocustomer/change",
      deleteandcleancustomerpath: "/1.0/front/customer/surrogate/delete",
      cleansurrogatepath: "/1.0/front/customer/surrogate/clean",
      surrogate: {
        columns: [
          {
            label: "Asiakasnumero",
            field: "customer_id",
          },
          {
            label: "Jäsennumero",
            field: "surrogate",
          },
          {
            label: "Nimi",
            field: "name",
          },
          {
            label: "Voimassa",
            field: "lastuntil",
          },
          {
            label: "Päivitetty",
            field: "updated",
          },
          {
            label: "Aktivoitu",
            field: "active",
          },
        ],
        rows: null,
      },
      customer: {
        columns: [
          {
            label: "Asiakasnumero",
            field: "id",
          },
          {
            label: "Jäsennumero",
            field: "surrogate",
          },
          {
            label: "Nimi",
            field: "name",
          },
          {
            label: "Luotu",
            field: "created",
          },
          {
            label: "Päivitetty",
            field: "updated",
          },
          {
            label: "Puhelinnumero",
            field: "tel",
          },
          {
            label: "Sähköposti",
            field: "email",
          },
          {
            label: "MobileId",
            field: "mobileloginid",
          },
        ],
        rows: null,
      },
      retrievebypath: "/1.0/front/customer/retrieve/surrogatewithcustomer/",
    };
  },
  methods: {
    startFindingMemberIdDataWithCode() {
      this.dataLoadReady = false;
      this.buttonsVisible = false;
      this.findMemberIdDataWithCode();
    },
    cleanSurrogate() {
      this.$http
        .post(this.cleansurrogatepath, { surrogate: this.foundSurrogate })
        .then((response) => {
          if (response.status == 200) {
            this.startFindingMemberIdDataWithCode();
            this.$notify.info({
              message: this.$t("member_id_cleaned"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutmedium,
            });
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch((error) => {
          return error;
        });
    },
    changeSurrogateToCustomer() {
      this.$http
        .post(this.changecustomersurrogatepath, { surrogate: this.foundSurrogate, customer_id: this.foundCustomerId })
        .then((response) => {
          if (response.status == 200) {
            this.startFindingMemberIdDataWithCode();
            this.$notify.info({
              message: this.$t("member_id_changed_to_customer"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutmedium,
            });
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch((error) => {
          return error;
        });
    },
    deleteMemberIdData() {
      this.$http
        .post(this.deleteandcleancustomerpath, { surrogate: this.foundSurrogate })
        .then((response) => {
          if (response.status == 200) {
            this.startFindingMemberIdDataWithCode();
            this.$notify.info({
              message: this.$t("member_id_deleted"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutmedium,
            });
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch((error) => {
          return error;
        });
    },
    findMemberIdDataWithCode() {
      this.$http
        .get(this.retrievebypath + this.surrogatetel)
        .then((response) => {
          if (response.status == 200) {
            this.foundCustomerId = response.data.customer[0].id;
            this.foundSurrogate = response.data.surrogate[0].surrogate;
            this.customerIdMismatch = this.foundCustomerId != response.data.surrogate[0].customer_id;
            this.customer.rows = response.data.customer;
            this.surrogate.rows = response.data.surrogate;

            this.dataLoadReady = true;
            this.buttonsVisible = true;
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch((error) => {
          return error;
        });
    },
  },
};
</script>

<style scoped>
.active-cyan input[type="text"] {
  border: 1px solid indigo;
  box-shadow: 0 1px 0 0 indigo;
}
</style>
